import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["autoplay", "slides"];
import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper";
import { SliderChild } from "..";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Because of issues between cjs and esm imports styles are imported separately
 * -For storybook they are imported as a bundle within the storybook file
 * -For the websites repo they are imported per module within the _app.tsx file
 * -- A search for "Import Swiper styles" will lead you to there location in each repo --
 */
export var Slider = props => {
  var {
    autoplay,
    slides
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var sliderContainer = useRef(null);
  var [maxWidth, setMaxWidth] = useState(null);
  var pagination = {
    clickable: true,
    renderBullet: function renderBullet(idx, className) {
      return "<span class=\"" + className + " !h-3 !w-3\"></span>";
    }
  }; //Prevents the slider expanding larger then its parent container

  var resizeTimeout;

  var updateMaxWidth = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      var _sliderContainer$curr, _sliderContainer$curr2, _sliderContainer$curr3, _sliderContainer$curr4;

      if (!sliderContainer.current) return; //setMaxWidth to 0 to prevent slider increasing container width

      setMaxWidth(0);
      sliderContainer.current.style.maxWidth = "0px";
      var parentContainerWidth = (_sliderContainer$curr = (_sliderContainer$curr2 = sliderContainer.current.closest("section")) == null ? void 0 : _sliderContainer$curr2.offsetWidth) != null ? _sliderContainer$curr : sliderContainer == null ? void 0 : (_sliderContainer$curr3 = sliderContainer.current) == null ? void 0 : (_sliderContainer$curr4 = _sliderContainer$curr3.parentElement) == null ? void 0 : _sliderContainer$curr4.offsetWidth;
      if (parentContainerWidth) setMaxWidth(parentContainerWidth);
    });
  };

  useEffect(() => {
    updateMaxWidth();
    window.addEventListener("resize", updateMaxWidth);
    return () => {
      window.removeEventListener("resize", updateMaxWidth);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", _extends({}, rest, {
    className: "slider",
    ref: sliderContainer,
    style: _extends({}, maxWidth && {
      maxWidth: maxWidth + "px"
    }),
    children: /*#__PURE__*/_jsx(Swiper, _extends({
      spaceBetween: 50,
      slidesPerView: 1,
      effect: "fade",
      pagination: pagination,
      modules: [Pagination, Autoplay, EffectFade],
      speed: 900
    }, autoplay && {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    }, {
      autoHeight: true,
      children: slides == null ? void 0 : slides.map((slide, idx) => /*#__PURE__*/_jsx(SwiperSlide, {
        children: /*#__PURE__*/_jsx(SliderChild, {
          title: slide.title,
          sub_title: slide.sub_title,
          image: slide.image,
          image_full_width: slide.image_full_width,
          button_text: slide.button_text,
          button_url: slide.button_url,
          button_color: slide.button_color,
          background_color: slide.background_color,
          text_color: slide.text_color,
          image_position: slide.image_position,
          image_mobile: slide.image_mobile,
          image_mobile_full_width: slide.image_mobile_full_width
        })
      }, "slide-" + idx))
    }))
  }));
};
//# sourceMappingURL=slider.js.map